import './App.scss';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
//My components
import SingIn from './Pages/SignIn';
import LogIn from './Pages/LogIn';
import Home from './Pages/Home'
import PostDetail from './Pages/PostDetail';
import Search from './Pages/Search'
import NewPost from './Pages/NewPost';

export default function App() {
  return (
    <>
    <Router>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/logIn">
          <LogIn/>
        </Route>
        <Route path="/signIn">
          <SingIn/>
        </Route>
        <Route path="/search/:keyword">
          <Search/>
        </Route>
        <Route path="/newPost">
          <NewPost/>
        </Route>
        <Route path="/postDetail/:postId">
          <PostDetail/>
        </Route>
      </Switch>
    </Router>
    </>






  );
}

